// Returns the name of a given component definition (class or function).
// Useful for wrapping component display names in higher-order components.

function getDisplayName(Component) {
	return Component.displayName || Component.name || 'Component';
}

export default getDisplayName;



// WEBPACK FOOTER //
// ./src/helpers/getDisplayName.js